import request from '@/utils/request'
// import request from '../../utils/request'
const api = {
  PortalInfo: '/Portal/GetPortalInfo',
  PortalInfoList1: '/Portal/GetPortalInfoList1',
  PortalInfoList2: '/Portal/GetPortalInfoList2',
  PortalInfoList3: '/Portal/GetPortalInfoList3',
  PortalInfoList4: '/Portal/GetPortalInfoList4',
  GetDeptInfo: '/Portal/GetDeptInfo',
  BulletinList: '/Portal/GetBulletinList',
  BulletinTyList: '/Portal/GetBulletinTyList',
  GetNewsList: '/Portal/GetNewsList',
  GetPurchaseResults: '/Portal/GetPurchaseResults',
  GetBiddingHall: '/Portal/GetBiddingHall'

}
export function GetPortalInfo (param) {
  return request({
    url: api.PortalInfo,
    method: 'post',
    data: param
  })
}

export function GetPortalInfoList1 (param) {
  return request({
    url: api.PortalInfoList1,
    method: 'post',
    data: param
  })
}

export function GetPortalInfoList2 (param) {
  return request({
    url: api.PortalInfoList2,
    method: 'post',
    data: param
  })
}

export function GetPortalInfoList3 (param) {
  return request({
    url: api.PortalInfoList3,
    method: 'post',
    data: param
  })
}
export function GetPortalInfoList4 (param) {
  return request({
    url: api.PortalInfoList4,
    method: 'post',
    data: param
  })
}

export function GetDeptInfo (param) {
  return request({
    url: api.GetDeptInfo,
    method: 'post',
    data: param
  })
}

export function GetBulletinList (param) {
  return request({
    url: api.BulletinList,
    method: 'post',
    data: param
  })
}

export function GetBulletinTyList (param) {
  return request({
    url: api.BulletinTyList,
    method: 'post',
    data: param
  })
}

export function GetNewsList () {
  return request({
    url: api.GetNewsList,
    method: 'post'
  })
}

export function GetPurchaseResults (param) {
  return request({
    url: api.GetPurchaseResults,
    method: 'post',
    data: param
  })
}
export function GetBiddingHall (param) {
  return request({
    url: api.GetBiddingHall,
    method: 'post',
    data: param
  })
}



// WEBPACK FOOTER //
// ./src/api/Home/index.js